import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { MembershipCancelView } from './cancel/cancel';
import { MembershipCategoriesView } from './categories/categories';
import { MembershipControllerModule } from './controllers/MembershipController';
import { MembershipDetailView } from './detail/detail';
import { MembershipLevelsView } from './levels/levels';
import { MembershipListView } from './list/list';
import { MembershipMappingView } from './mapping/mapping';
import { MembershipOfferingsView } from './offerings/offerings';
import { MembershipPricingView } from './pricing/pricing';
import { MembershipRetailView } from './retail/membershipRetail';
import { MembershipRulesView } from './rules/rules';
import { MembershipFormsView } from './forms/forms';

export const MembershipView = angular
  .module('acme.view.application.membership', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.directive.upload',
    'acme.common.directive.dataGrid',
    'acme.common.directive.detailList',
    MembershipListView,
    MembershipDetailView,
    MembershipCategoriesView,
    MembershipLevelsView,
    MembershipRulesView,
    MembershipMappingView,
    MembershipOfferingsView,
    MembershipPricingView,
    MembershipRetailView,
    MembershipCancelView,
    MembershipFormsView,
    'acme.view.application.dataGrid.controllers',
    MembershipControllerModule,
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const membership = {
      name: 'application.membership',
      url: '/membership',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'MembershipController',
          templateUrl: 'views/application/views/membership/membership.tpl.html',
        },
      },
      data: {
        pageTitle: 'Membership',
        permissions: ['MEMBERSHIP_VIEW'],
      },
    };

    $stateProvider.state(membership);
  }).name;
